import api from "!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@4.47.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/sass-loader@10.5.2_sass@1.44.0_webpack@4.47.0/node_modules/sass-loader/dist/cjs.js!../../../../node_modules/.pnpm/sass-resources-loader@2.2.5/node_modules/sass-resources-loader/lib/loader.js??ref--5-oneOf-1-3!./_toast-message.scss";

var options = {"attributes":{"class":"cog-style"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};